import { AppBar } from '@material-ui/core';
import * as React from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'typesafe-actions';
import { useHistory } from 'react-router-dom';
import { Row } from '../../modules/common/components/elements';
import Link from '../../modules/common/components/Link';
import { AppState } from '../../redux/reducers';
import { ReactComponent as DinoLogo } from '../../svg/dino_eat_logo.svg';
import { ReactComponent as BackIcon } from '../../svg/icon_back.svg';
import { HEADER_HEIGHT } from '../constants';
import Menu from './Menu';

const mapStateToProps = (state: AppState) => {
  return { router: state.router };
};
interface Props extends ReturnType<typeof mapStateToProps> {
  dispatch: ThunkDispatch<AppState, null, Action<string>>;
  noSticky?: boolean;
}

const DefaultHeader: React.FunctionComponent<Props> = (props) => {
  const history = useHistory();
  const { noSticky, dispatch } = props;

  const isWebview = () => {
    const { standalone }: any = window.navigator;
    const userAgent = window.navigator.userAgent.toLowerCase();
    const safari = /safari/.test(userAgent);
    const ios = /iphone|ipod|ipad/.test(userAgent);
    return (ios && !standalone && !safari) || userAgent.includes('wv');
  };
  const isHome = () => {
    return window.location.pathname === '/';
  };
  const handleGoBack = () => {
    // dispatch(goBackAction());
    if (isHome()) {
      window.location.href = 'https://khampha.dinogo.com/dinoeat/backapp';
      // history.push('/dinoeat/backapp');
    } else {
      history.goBack();
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      }, 100);
    }
  };
  return (
    <>
      <AppBar
        position={noSticky ? 'relative' : 'sticky'}
        style={{
          height: HEADER_HEIGHT,
          backgroundColor: 'white',
          boxShadow: '0 0 6px rgba(0,0,0,0.1)',
          borderRadius: 0,
        }}
      >
        <Row
          style={{
            height: '100%',
            paddingRight: '16px',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          {isWebview() && (
            <BackIcon
              style={{
                position: 'absolute',
                left: 15,
                zIndex: 15,
              }}
              onClick={handleGoBack}
            />
          )}
          <Link style={{ display: 'flex' }} to="/">
            {/* <img style={{ maxWidth: 130 }} src={logo} alt="" /> */}
            <DinoLogo />
          </Link>
          {/* <Badge /> */}
        </Row>
      </AppBar>
      <Menu />
    </>
  );
};

export default connect(mapStateToProps)(DefaultHeader);
